// extracted by css-extract-rspack-plugin
export default {"bouncingDots":"DotsTypingLoader-module__bouncingDots","dot":"DotsTypingLoader-module__dot","bounce":"DotsTypingLoader-module__bounce"};